/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { FormButtons, SelectControl } from 'components/elements';
import { useReactHookFormErrorMap, useFetchTimeZones } from 'hooks';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function TimezoneUpdateForm({ onSubmit, timezone }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  const [isEditable, setIsEditable] = useState(false);
  const { data: timezones } = useFetchTimeZones();
  const { handleSubmit, control, reset, getValues, setError, setValue } = useForm({
    mode: 'onSubmit',
    defaultValues: { timezone },
  });
  useEffect(() => {
    setValue('timezone', timezone);
  }, [timezone]);

  const mapErrorToForm = useReactHookFormErrorMap(getValues, setError, '');

  return (
    <form
      className={classes.timezoneUpdateForm}
      onSubmit={handleSubmit((data) => {
        onSubmit(data)
          .then(() => setIsEditable(false))
          .catch((error) => {
            mapErrorToForm(error);
          });
      })}
    >
      <FormButtons isEditMode={isEditable} onReset={() => reset({ timezone })} onModeUpdate={setIsEditable}>
        <div className={classes.field}>
          <SelectControl isEditMode={isEditable} options={timezones} control={control} name="timezone" labelText={t('timezone')} />
        </div>
      </FormButtons>
    </form>
  );
}

TimezoneUpdateForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  timezone: PropTypes.string,
};

TimezoneUpdateForm.defaultProps = {
  timezone: '',
};

export default TimezoneUpdateForm;
